import { UnreachableCaseError } from '@errors/unreachable';
import type {
  FieldId,
  LineItemValueId,
  QuantityBreakValueId,
  ValueId,
} from '@snap-types/models/auto-configurator/state';

export function fieldIdToValueId(fieldId: FieldId, uuid: string): ValueId {
  const model = fieldId.model;

  switch (model) {
    case 'lineItem':
      return {
        model: 'lineItem',
        key: fieldId.key,
        uuid,
      } satisfies LineItemValueId;

    case 'quantityBreak':
      return {
        model: 'quantityBreak',
        key: fieldId.key,
        uuid,
      } satisfies QuantityBreakValueId;

    /* v8 ignore next 2 */
    default: {
      throw new UnreachableCaseError(model);
    }
  }
}
